import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { leadFormStateOptions } from '@/features/privateCompanyLeadsFunnel/constants/leadFormStateOptions.constant'
import usePrivateCompanyLead from '@/features/privateCompanyLeadsFunnel/hooks/usePrivateCompanyLead'
import { useParams } from 'react-router-dom'

const Update = () => {
  const { id } = useParams()
  const {
    data: privateClientCompanyLead,
    isPending: privateClientCompanyLeadIsPending,
    error: privateClientCompanyLeadError = {} as any,
    refetch: refetchPrivateClientCompany,
  } = usePrivateCompanyLead(id || '')

  if (privateClientCompanyLeadIsPending) return <Box>Carregando...</Box>

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={privateClientCompanyLeadError?.status}
      refetchFunction={refetchPrivateClientCompany}
      notFoundButtonText='Ir para Funil de clientes privados'
    >
      {!privateClientCompanyLeadIsPending && privateClientCompanyLead && id && (
        <>
          {leadFormStateOptions.map(({ value, comp: Comp }) => {
            if (privateClientCompanyLead.state !== value) return null
            return <Comp key={privateClientCompanyLead.id} id={id} privateCompanyLead={privateClientCompanyLead} />
          })}
        </>
      )}
    </ErrorMessageWrapper>
  )
}

export default Update
